import {json} from "p3";
import common from "../common";
import definitions from "../definitions";
import GameScene from "../scenes/GameScene";
import settings from "../settings";
import {getMarketRegion, getUserCountryCode, getUserLanguage, getUserMarketRegion, locale} from "./index";

export default class Tracking {
    /**
     * @param {string} appName
     * @param {string} franchise
     */
    constructor(appName, franchise) {
        this._appName = appName;
        this._franchise = franchise;
        this._languageState = definitions.TRACKING.LANGUAGE_STATE.DEFAULT;

        if(window.ACPCore) {
            ACPCore.extensionVersion(function(version) {
                console.log('ACPCore version: ' + version);
            }, function(error) {
                console.log(error);
            });
        }
    }

    //turnerintgameivandoequests, turnerintgameappsglobal

    /**
     * @param {string} state
     */
    setLanguageState(state) {
        this._languageState = state;
    }

    /**
     * @param {string} type
     * @param {object} metadata
     */
    trackEvent(type, metadata) {
        const payload = Object.assign({}, metadata, {
            //pageName: json('urls')[common.config.language],
            type: type,
            user_lang: this.userLanguage,
            market_region: this.marketRegion,
            franchise: this._franchise
        });

        if (settings.APP) {
            payload.app_name = "app|" + this.appName;
        } else {
            payload.domain = "web|" + this.domain;
        }

        if(typeof json('urls')[common.config.language] == "string"){
            payload.pageName = json('urls')[common.config.language];
        } else {
            const obj = json('urls')[common.config.language];
            for (let i in obj) {
                if(obj[i].includes(this.domainForPageName)) {
                    payload.pageName = obj[i];
                    break;
                }
            }
        }

        if (settings.APP) {
            console.log("app event tracked:", payload);
            if(window.ACPCore) {
                ACPCore.trackAction("interaction", payload, (res) => {
                    console.log('tracking success', res);
                }, (err) => {
                    console.warn('tracking error', err);
                });
            }
        } else if (turner_metadata) {
            console.log("web event tracked:", payload);
            turner_metadata.trackAction.push({
                "type": "interaction",
                "data": payload
            });
        }
    }

    getSection(id) {
        id = id || (GameScene.active ? GameScene.active.loadedLevel : null);
        if (id != null) {
            let sectionData = json(id);
            if (sectionData && sectionData.metadata && sectionData.metadata.name) {
                return json("locale")[sectionData.metadata.name].en;
            }
        }
        return null;
    }

    /**
     * @return {string}
     */
    get appName() {
        return this._appName;
    }

    /**
     * @return {string}
     */
    get franchise() {
        return this._franchise;
    }

    /**
     * @return {string}
     */
    get domain() {
        console.log('DOMAIN', parent !== window);
        if (parent === window) {
            return window.location.hostname;
        } else {
            let domain = document.referrer.replace("http://", "").replace("https://", "").replace("www.", "");
            domain = domain.split("/")[0];
            return domain;
        }
    }

    /**
     * @return {string}
     */
    get domainForPageName() {
        let domain;
        if (parent === window) {
            domain = window.location.hostname;
        } else {
            domain = document.referrer;
        }
        domain = document.referrer.replace("http://", "").replace("https://", "").replace("www.", "");
        domain = domain.split("/")[0];
        console.log('DOMAIN FOR PAGENAME', parent !== window, domain);
        return domain;
    }

    get url() {
        console.log('PAGEVIEW', parent !== window, parent, window, document);
        return parent !== window ? document.referrer : window.location.href;
    }

    /**
     * @return {string}
     */
    get userLanguage() {
        //return common.config.language.toLowerCase() + "_" + getUserCountryCode().toLowerCase() + "|" + this._languageState
        return getUserLanguage(common.config.language.toLowerCase()) + "|" + this._languageState;
    }

    /**
     * @return {string}
     */
    get marketRegion() {
        if (common.config.language == "pt-br" || common.config.language == "es-419")
            return "LATAM";
        return "EMEA";
        //return getMarketRegion(common.config.language.toLowerCase());
        //return getUserMarketRegion().toLowerCase();
    }

        /**
     * @return {string}
     */
    get progress() {
        if (common.saveData.activeSlot && common.saveData.activeSlot.player && common.saveData.activeSlot.player.lastQuest) {
            let spl = common.saveData.activeSlot.player.lastQuest.split('|');
            console.log(spl);
            console.log(json(spl[0]));
            return json('locale')[(json(spl[0]).quests[spl[1]].name)].en;
        }
        return 'none';
    }
}